import type { Dispatch, SetStateAction } from 'react';

import { CalendarPlusIcon, ChevronLeftIcon } from 'lucide-react';

import type { TabValue } from '@/hooks/meeting';

import { Button } from '@/components/ui/button';
import { DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { FeaturedIcon } from '@/components/ui/featured-icon';
import { SearchInput } from '@/components/ui/input';

interface MeetingFormHeaderProps {
  tabs: TabValue;
  setTabs: Dispatch<SetStateAction<TabValue>>;
  searchValue: string;
  setSearchValue: Dispatch<SetStateAction<string>>;
}

export default function MeetingFormHeader(meetingFormHeaderProps: MeetingFormHeaderProps) {
  const { tabs, setTabs, setSearchValue } = meetingFormHeaderProps;

  if (tabs === 'main') {
    return (
      <DialogHeader className={'border-border-primary bg-card items-center gap-2 border-b'}>
        <FeaturedIcon size={'lg'}>
          <CalendarPlusIcon />
        </FeaturedIcon>
        <div className={'flex min-w-0 grow flex-col gap-0.5'}>
          <DialogTitle>Spotkanie</DialogTitle>
          <DialogDescription className={'text-muted-foreground text-xs'}>Wprowadź dane spotkania.</DialogDescription>
        </div>
      </DialogHeader>
    );
  }

  return (
    <DialogHeader className={'border-border-primary bg-card gap-3 border-b'}>
      <DialogTitle className={'sr-only'}>{tabs === 'usersSelect' ? 'Dodaj użytkowników' : 'Dodaj grupy'}</DialogTitle>
      <Button variant={'outline'} onClick={() => setTabs('main')}>
        <ChevronLeftIcon />
      </Button>
      <SearchInput setValue={setSearchValue} />
    </DialogHeader>
  );
}
